import React from 'react';

const CompatibilityMatrix = ({ selectedAdvisor }) => {
  if (!selectedAdvisor) return null;

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="bg-gray-50 border-b p-3">
        <h3 className="font-semibold text-gray-700">EXPERIENCE RANKING MATRIX</h3>
      </div>
      
      <div className="p-4">
        <div className="flex items-center mb-6 pb-3 border-b">
          <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
            <img 
              src={selectedAdvisor.image} 
              alt={selectedAdvisor.name} 
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <h4 className="font-medium text-gray-800 text-lg">{selectedAdvisor.name}</h4>
            <p className="text-gray-500">{selectedAdvisor.experience} of wealth management experience</p>
          </div>
        </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Client Types */}
          <div>
            <h4 className="font-medium text-gray-800 mb-3">Client Personas</h4>
            <div className="space-y-3">
              {selectedAdvisor.clientTypes.map((item, idx) => (
                <div key={idx}>
                  <div className="flex justify-between text-sm mb-1">
                    <span>{item.type}</span>
                    <span className="font-medium">{item.score}%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-purple-500 rounded-full" 
                      style={{ width: `${item.score}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Industries */}
          <div>
            <h4 className="font-medium text-gray-800 mb-3">Industries</h4>
            <div className="space-y-3">
              {selectedAdvisor.industries.map((item, idx) => (
                <div key={idx}>
                  <div className="flex justify-between text-sm mb-1">
                    <span>{item.name}</span>
                    <span className="font-medium">{item.score}%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-blue-500 rounded-full" 
                      style={{ width: `${item.score}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Investment Types */}
          <div>
            <h4 className="font-medium text-gray-800 mb-3">Investment Types</h4>
            <div className="space-y-3">
              {selectedAdvisor.investmentTypes.map((item, idx) => (
                <div key={idx}>
                  <div className="flex justify-between text-sm mb-1">
                    <span>{item.name}</span>
                    <span className="font-medium">{item.score}%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-green-500 rounded-full" 
                      style={{ width: `${item.score}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Client Goals */}
          <div>
            <h4 className="font-medium text-gray-800 mb-3">Client Goals</h4>
            <div className="space-y-3">
              {selectedAdvisor.clientGoals.map((item, idx) => (
                <div key={idx}>
                  <div className="flex justify-between text-sm mb-1">
                    <span>{item.name}</span>
                    <span className="font-medium">{item.score}%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-amber-500 rounded-full" 
                      style={{ width: `${item.score}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t">
          <h4 className="font-medium text-gray-800 mb-3">Ideal Client Match Profile</h4>
          <div className="bg-purple-50 rounded-lg p-3">
            <p className="text-sm text-purple-700">
              Based on this advisor's experience matrix, they are best suited for 
              <span className="font-semibold"> {selectedAdvisor.clientTypes[0].type}</span> in the 
              <span className="font-semibold"> {selectedAdvisor.industries[0].name}</span> industry 
              who are focused on <span className="font-semibold">{selectedAdvisor.clientGoals[0].name.toLowerCase()}</span> and 
              prefer <span className="font-semibold">{selectedAdvisor.investmentTypes[0].name.toLowerCase()}</span> strategies.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompatibilityMatrix;